module.exports = __webpack_public_path__ + "2e2a233c54c4b89b4453572b8ce136de.png";